import React, { useState, useEffect } from 'react';
import { IntlProvider } from 'react-intl';
import { Router } from 'react-router-dom';
import CustomAuth from '@semrush/sso/custom';
import { I18nProvider } from '@semcore/core/lib/utils/enhances/WithI18n';

import history from '@authFlow/App/history';
import { FORM } from '@authFlow/App/variables';
import ExperimentContext, {
  ExperimentT,
} from '@authFlow/utils/ExperimentContext';
import AppRoutes from '@authFlow/App/Routing/AppRouter';
import { PaymentFormProvider } from '@authFlow/utils/PaymentFormContext';

import type { CustomAuthT } from '@authFlow/types/types';

type Props = {
  ssoEnv: string;
  isChina: boolean;
  textCaptchaUrl: string;
  countryCode: string;
  headerTitleLogin: string;
  signupOfferTitle: string;
  messages: Record<string, never>;
  locale: string;
  flowTheme: string;
};

const App = ({ messages, locale, ...props }: Props) => {
  const [experiments, setExperiments] = useState<ExperimentT>({});

  const customAuth: CustomAuthT = new CustomAuth(
    {
      loginForm: FORM.LOGIN,
      samlLoginForm: FORM.SAML,
      regForm: FORM.REG,
      restoreForm: FORM.RESTORE,
      needPassForm: FORM.CONNECT,
      changeForm: FORM.CHANGE,
      socialLogin: FORM.SOCIAL,
      captchaDivId: 'recaptcha',
      modules: ['error_handling_v2'],
    },
    props.ssoEnv,
  );

  useEffect(() => {
    performance.mark('auth__render_app');
  }, []);

  return (
    <PaymentFormProvider>
      <IntlProvider defaultLocale={'en'} messages={messages} locale={locale}>
        <I18nProvider value={locale}>
          <ExperimentContext.Provider
            value={{
              experiments,
              setExperiments,
            }}
          >
            <Router history={history}>
              <AppRoutes
                auth={customAuth}
                isChina={props.isChina}
                textCaptchaUrl={props.textCaptchaUrl}
                countryCode={props.countryCode}
                signupOfferTitle={props.signupOfferTitle}
                flowTheme={props.flowTheme}
              />
            </Router>
            <div id={'recaptcha'} />
          </ExperimentContext.Provider>
        </I18nProvider>
      </IntlProvider>
    </PaymentFormProvider>
  );
};

export default App;
